import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper';
import { Location } from "react-router";

import {
    ACTION_ROUTING_UPDATE_LOCATION,
    RoutingAction
} from '../actions/routing';

export interface IRoutingState {
    location: Location;
}

const initialState: IRoutingState = {
    location: {
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash
    } as Location
};


const RoutingReducer: Reducer<IRoutingState> = ((state: IRoutingState = initialState, action: RoutingAction) => {
    switch (action.type) {
        case ACTION_ROUTING_UPDATE_LOCATION:

            const newState: IRoutingState = update(state, {
                $set: {
                    location: action.location
                }
            });

            return newState;

    }

    return state;
}) as any

export default RoutingReducer;